module.exports = __webpack_public_path__ + "static/media/aws-academy-graduate-aws-academy-introduction-to-cloud-semester-2.753c1689.png";